<template>
  <div class="mainbody">
    <div v-cloak>
      <div class="location">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item> 管理中心 </el-breadcrumb-item>
          <el-breadcrumb-item>测算管理</el-breadcrumb-item>
          <el-breadcrumb-item>测算列表</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="toolbar-box">
        <div class="list-box">
          <div class="l-list">
            <el-button-group>
              <el-button
                type="primary"
                icon="el-icon-plus"
                @click="addLinkUrl"
                v-if="flagAdd"
                >新增</el-button
              >
              <el-button
                type="primary"
                style="margin-left: 20px"
                icon="el-icon-plus"
                @click="openCity"
                v-if="flagAdd"
                >新增地区</el-button
              >
              <el-button
                style="margin-left: 20px"
                type="primary"
                icon="el-icon-plus"
                @click="moreParameters"
                v-if="flagAdd"
                >更多参数</el-button
              >
            </el-button-group>
          </div>
        </div>
      </div>

      <div class="content-box">
        <el-card class="table-card">
          <el-table
            ref="multipleTable"
            v-loading="loading"
            :data="listData"
            stripe
            class="table-list"
            @selection-change="handleSelectionChange"
          >
            <el-table-column width="15"></el-table-column>
            <el-table-column label="地区">
              <template slot-scope="scope">
                <h4>
                  {{ scope.row.region }}
                </h4>
              </template>
            </el-table-column>
            <el-table-column prop="priceJ" label="尖时"></el-table-column>
            <el-table-column prop="priceF" label="峰时"></el-table-column>
            <el-table-column prop="priceP" label="平时"></el-table-column>
            <el-table-column prop="priceG" label="谷时"></el-table-column>

            <el-table-column fixed="right" label="操作" width="180">
              <template slot-scope="scope">
                <el-button
                  size="mini"
                  icon="el-icon-search"
                  title="查看"
                  v-if="flagLook"
                  @click="look(scope.row.id)"
                ></el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <div class="pager-box">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { AxiosAjax, getCompanyData } from "../../js/axios.config";
export default {
  data() {
    return {
      companyId: "",
      disabled: false,
      companyList: [],
      loading: false,
      keyword: "",
      totalCount: 0,
      pageSize: 10,
      pageIndex: 1,
      listData: [],
      flagAdd: false,
      flagDel: false,
      flagDel: false,
      flagUpdate: false,
    };
  },
  mounted() {
    this.buttonShow();
  },
  methods: {
    buttonShow() {
      if (localStorage.getItem("fx_menu_selected_jurisdiction")) {
        let jurisdiction = JSON.parse(
          localStorage.getItem("fx_menu_selected_jurisdiction")
        );
        let obj = jurisdiction[0].children.find(
          (obj) => obj.title === "系统中心"
        );
        let obj1 = obj.children.find((obj) => obj.title === "测算配置");
        if (obj1.resources.find((item) => item.name == "View")) {
          this.flagLook = true;
        } else {
          this.flagLook = false;
        }
        if (obj1.resources.find((item) => item.name == "Delete")) {
          this.flagDel = true;
        } else {
          this.flagDel = false;
        }
        if (obj1.resources.find((item) => item.name == "Edit")) {
          this.flagUpdate = true;
        } else {
          this.flagUpdate = false;
        }
        if (obj1.resources.find((item) => item.name == "Add")) {
          this.flagAdd = true;
        } else {
          this.flagAdd = false;
        }
        obj1.resources.forEach((element) => {
          if (element.name == "View") {
            this.flagLook = element.selected;
          }
          if (element.name == "Add") {
            this.flagAdd = element.selected;
          }
          if (element.name == "Delete") {
            this.flagDel = element.selected;
          }
          if (element.name == "Edit") {
            this.flagUpdate = element.selected;
          }
        });
      }
    },

    //初始化工具栏
    initLoad: function () {
      let _this = this;

      _this.companyList = getCompanyData();
      if (window.localStorage.getItem("fx_login_companyType") == "1") {
        _this.companyId = window.localStorage.getItem("fx_login_companyId");
        _this.disabled = true;
      }
    },
    //加载数据
    initData: function () {
      let _this = this;

      AxiosAjax({
        url: "/calculation/region/price",

        success: function (res) {
          if (res.data.code == 200) {
            _this.listData = res.data.data;
          }
        },
        error: function (err) {
          _this.listData = [];
        },
        complete: function () {
          _this.loading = false;
        },
      });
    },
    addLinkUrl() {
      this.$router.push({ name: "CalculationEdit", query: { add: "add" } });
    },
    //跳转链接
    look: function (id) {
      this.$router.push({
        name: "CalculationEdit",
        query: { id, type: "look" },
      });
    },

    //选中第几行
    handleSelectionChange: function (val) {
      this.multipleSelection = val;
    },
    //每页显示数量
    handleSizeChange: function (val) {
      if (this.pageSize != val) {
        this.pageSize = val;
        this.initData();
      }
      //console.log('每页 ${val} 条');
    },
    //跳转到第几页
    handleCurrentChange: function (val) {
      if (this.pageIndex != val) {
        this.pageIndex = val;
        this.initData();
      }
      //console.log('当前页: ${val}');
    },
    setCompanyId: function (obj) {
      this.companyId = obj.toString();
    },
    openCity() {
      this.$prompt("请输入地区", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(({ value }) => {
          AxiosAjax({
            method: "post",
            url: "/calculation/region/addRegion",
            data: { region: value },
            loading: true,
            success: function (res) {
              if (res.data.code == 200) {
                this.$message({
                  type: "success",
                  message: "新增成功",
                });
              } else {
                this.$message({
                  type: "error",
                  message: res.data.msg,
                });
              }
              this.initData(); //重新加载列表
            },
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
    },
    moreParameters() {
      this.$router.push({ path: "/CalculationMoreParameters" });
    },
  },
  created: function () {
    //加载数据
    this.initLoad();
    this.initData();
  },
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/Calculation/Calculation.vue